// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reviewModal-body{min-width:27vw}.reviewModal .modalV2-header{border-bottom:0}.reviewModal .modalV2-content-wrapper{text-align:center}.reviewModal .reviewIcon{width:170px;height:52px;display:inline-block}.reviewModalBody{padding:40px 90px 32px;display:flex;flex-direction:column;justify-content:center;align-items:center;width:600px;box-sizing:border-box}.reviewModalBodyTitle{margin-bottom:12px}.reviewModalBody .transferBtn{margin-right:8px}\n", ""]);
// Exports
module.exports = exports;
